// 日期格式化
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
      return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      } else if (typeof time === 'string') {
        time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
      }
      if ((typeof time === 'number') && (time.toString().length === 10)) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
}

/**
 * 字符串转Date
 * @param {*} str "2025-05-12 15:57:00"
 * @returns 
 */
export function toDate(dateStr){
  const parts = dateStr.split(/[- :]/); // 使用正则拆分
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // 月份从 0 开始
  const day = parseInt(parts[2], 10);
  const hours = parseInt(parts[3], 10);
  const minutes = parseInt(parts[4], 10);
  const seconds = parseInt(parts[5], 10);
  const date = new Date(year, month, day, hours, minutes, seconds);
  // console.log(date); // 输出本地时间对应的 Date 对象
  return date
}

export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  var context = "";
  if (r != null)
      context = decodeURIComponent(r[2]);
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined" ? "" : context;
}

/**
 * 直接下载指定链接
 * @param {*} url 全链接
 * @param {*} fileName 文件名字
 */
export function downloadFile(url, fileName) {
  return new Promise((resolve,reject) => {
    let r = { status: 0, msg: '成功' }
    fetch(url).then(res => res.blob().then(blob => {
      var a = document.createElement('a')
      var url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
      resolve(r)
    })).catch(err=>{
      // console.log(err)
      r.status = 99
      r.msg = '下载失败'
      resolve(r)
    })
  })
}

/**
 * 自动识别船舶所属航线并判断是否偏航 (偏航大于300就不算)
 * @param {Array<number>} p 船舶当前位置，格式[经度, 纬度]
 * @param {Array<Object>} wayList 航线列表
 * @returns {boolean} true-偏航，false-未偏航
 */
export function isShipOffCourse(p, wayList) {
    // 参数有效性检查
    if (!Array.isArray(p) || p.length !== 2 || !Array.isArray(wayList) || wayList.length === 0) {
        return false; // 无效输入视为偏航
    }
    console.log(p)
    console.log(wayList)

    const [shipLon, shipLat] = p;

    /**
     * 两点间欧氏距离（平面）
     */
    function distance(p1, p2) {
        const dx = p1.x - p2.x;
        const dy = p1.y - p2.y;
        return Math.hypot(dx, dy);
    }

    /**
     * 点到线段的最短距离及投影参数t
     */
    function pointToSegmentDistanceAndT(point, segStart, segEnd) {
        const abx = segEnd.x - segStart.x;
        const aby = segEnd.y - segStart.y;
        const apx = point.x - segStart.x;
        const apy = point.y - segStart.y;

        const dot = abx * apx + aby * apy;
        const abLenSq = abx * abx + aby * aby;

        if (abLenSq === 0) {
            return { dist: distance(point, segStart), t: 0 };
        }

        let t = dot / abLenSq;
        let projX, projY;

        if (t <= 0) {
            projX = segStart.x;
            projY = segStart.y;
            t = 0;
        } else if (t >= 1) {
            projX = segEnd.x;
            projY = segEnd.y;
            t = 1;
        } else {
            projX = segStart.x + t * abx;
            projY = segStart.y + t * aby;
        }

        const dist = distance(point, { x: projX, y: projY });
        return { dist, t };
    }

    // 为了计算经纬度 -> 米制平面坐标，采用动态参考纬度（每个航段独立计算会更准，但为了性能，使用全局平均纬度）
    // 但自动识别阶段需要比较不同航线的距离，建议每个航段分别转换以保证精度
    function toLocalMeters(lon, lat, refLat) {
        const metersPerDegLon = 111319 * Math.cos(refLat * Math.PI / 180);
        const metersPerDegLat = 111319;
        return {
            x: lon * metersPerDegLon,
            y: lat * metersPerDegLat
        };
    }

    // ========= 第一步：自动识别船舶最接近的航线 =========
    let bestMatch = {
        routeId: null,
        segmentIndex: -1,
        minDist: Infinity,
        segmentDist: Infinity,
        segmentT: 0,
        matchedSegment: null,
        startLocal: null,
        endLocal: null
    };

    for (const route of wayList) {
        if (!route.routeSegments || !Array.isArray(route.routeSegments)) continue;

        const segments = route.routeSegments;
        for (let idx = 0; idx < segments.length; idx++) {
            const seg = segments[idx];
            if (!seg.startPoint || !seg.endPoint) continue;

            // 用该航段的中点纬度作为参考，保证该航段内的投影精度
            const refLat = (seg.startPoint.lat + seg.endPoint.lat) / 2;
            const shipLocal = toLocalMeters(shipLon, shipLat, refLat);
            const startLocal = toLocalMeters(seg.startPoint.lon, seg.startPoint.lat, refLat);
            const endLocal = toLocalMeters(seg.endPoint.lon, seg.endPoint.lat, refLat);

            const { dist, t } = pointToSegmentDistanceAndT(shipLocal, startLocal, endLocal);

            if (dist < bestMatch.minDist) {
                bestMatch = {
                    routeId: route.routerId,
                    segmentIndex: idx,
                    minDist: dist,
                    segmentDist: dist,
                    segmentT: t,
                    matchedSegment: seg,
                    startLocal: startLocal,
                    endLocal: endLocal,
                    refLat: refLat
                };
            }
        }
    }

    // 如果没有找到任何有效航段，视为默认不偏航
    if (bestMatch.routeId === null) {
        return false;
    }

    // 此时 bestMatch.routeId 就是自动识别出的船舶当前归属航线
    // ========= 第二步：在该航线内部，精确匹配当前所处航段（考虑顺序和投影点位置） =========
    const currentRoute = wayList.find(r => r.routerId === bestMatch.routeId);
    const allSegments = currentRoute.routeSegments;
    const segmentsInfo = [];

    // 重新计算该航线所有航段的信息（使用各自参考纬度，保证精度）
    for (let i = 0; i < allSegments.length; i++) {
        const seg = allSegments[i];
        if (!seg.startPoint || !seg.endPoint || typeof seg.yawDistance !== 'number') continue;

        const refLat = (seg.startPoint.lat + seg.endPoint.lat) / 2;
        const shipLocal = toLocalMeters(shipLon, shipLat, refLat);
        const startLocal = toLocalMeters(seg.startPoint.lon, seg.startPoint.lat, refLat);
        const endLocal = toLocalMeters(seg.endPoint.lon, seg.endPoint.lat, refLat);

        const { dist, t } = pointToSegmentDistanceAndT(shipLocal, startLocal, endLocal);
        segmentsInfo.push({
            index: i,
            segment: seg,
            dist,
            t,
            startLocal,
            endLocal
        });
    }

    if (segmentsInfo.length === 0) return false;

    // 智能匹配当前航段（与之前逻辑相同）
    let currentSegmentInfo = null;
    const insideSegments = segmentsInfo.filter(info => info.t >= 0 && info.t <= 1);
    if (insideSegments.length > 0) {
        currentSegmentInfo = insideSegments.reduce((a, b) => (a.dist < b.dist ? a : b));
    } else {
        const beforeFirst = segmentsInfo.filter(info => info.t < 0);
        const afterLast = segmentsInfo.filter(info => info.t > 1);
        if (beforeFirst.length > 0) {
            currentSegmentInfo = beforeFirst.reduce((a, b) => (a.t > b.t ? a : b));
        } else if (afterLast.length > 0) {
            currentSegmentInfo = afterLast.reduce((a, b) => (a.t < b.t ? a : b));
        } else {
            currentSegmentInfo = segmentsInfo.reduce((a, b) => (a.dist < b.dist ? a : b));
        }
    }

    // 最终偏航判断：到当前航段的距离 > 该航段的偏航阈值
    const yawDist = currentSegmentInfo.segment.yawDistance;
    // console.log('当前航段距离='+currentSegmentInfo.dist+'  阀值='+yawDist)

    return currentSegmentInfo.dist > yawDist && currentSegmentInfo.dist < 300; // 偏离小于300米才算，兼容多条航线的情况
}
